// extracted by mini-css-extract-plugin
export var gif = "_mm-0";